import { GRAPH_WINDOW_OFFSET_X } from "./constants/constants"
import { DefaultValues } from "./interface/DefaultValues"


/**
 * Interface to represent a 2D point.
 */
export interface Point {
    x: number,
    y: number,
}


/**
 * Interface to represent a rectangle.
 */
export interface Rectangle {
    origin: Point,
    width: number,
    height: number
}

/**
 * Function that converts DOM coordinates into SVG coordinates.
 * Source: https://www.sitepoint.com/how-to-translate-from-dom-to-svg-coordinates-and-back-again/
 * @param x Given x client in client coordinates.
 * @param y Given y client in client coordinates.
 * @returns SVG coordinates.
 */
export function computeSVGCoords(x: number, y: number) {
    const svg = (document.getElementById("svg-container") as unknown) as SVGSVGElement
    const pt = svg.createSVGPoint()
    pt.x = x
    pt.y = y
    const svgCoords = pt.matrixTransform( svg.getScreenCTM()?.inverse() )
    return svgCoords
}


/**
 * Finds a point on rectangle that connects to given point,
 * @param dest Destination point.
 * @param origin Origin point.
 * @param rect Given rectangle.
 * @returns Point that connects to destination.
 */
export function getClosestPointFromRect(dest: Point, origin: Point, rect: Rectangle) {
    if (dest.x > origin.x) {
        // Right edge.
        return {x: rect.origin.x + rect.width, y: origin.y}
    } else {
        // Left edge.
        return {x: rect.origin.x, y: origin.y}
    }
}


/**
 * Checks if x is too far right.
 * @param x Given x in client windows coordinates.
 * @returns True if x is too far right.
 */
export function isOverflowX(x: number) {
    const svg = (document.getElementById("svg-container") as unknown) as SVGSVGElement
    if (svg) {
        const svgWidth = svg.width.baseVal.value
        const points = computeSVGCoords(svgWidth, 0)
        const rectWidth = points.x * 0.3
        return {isOverflow: x + rectWidth > svgWidth, width: rectWidth}
    } else {
        return {isOverflow: false, width: 0}
    }
}

/**
 * Changes the position of the rectangle if it is too far right.
 * @param x Origin of the rectangle.
 * @returns The new x of the end of the rectangle
 */
export function adjustRectX(x: number) {
    const overflowParam = isOverflowX(x)
    return overflowParam.isOverflow ? x - overflowParam.width - 2 * GRAPH_WINDOW_OFFSET_X : x + GRAPH_WINDOW_OFFSET_X
}

/**
 * Changes the position of the arrow if it is too far right.
 * @param x Origin of the polygon.
 * @returns The new x of the end of the polygon
 */
export function adjustArrowX(x: number) {
    return isOverflowX(x).isOverflow ? x - GRAPH_WINDOW_OFFSET_X : x + GRAPH_WINDOW_OFFSET_X
}


export function setStyle(interfaceConfig: any) {
    if (!("theme" in interfaceConfig)) {
        return;
    }
    // Set Background and font color.
    const elements = document.getElementsByTagName("body");
    const bodyEl = elements[0] as HTMLBodyElement;
    bodyEl.style.backgroundColor = interfaceConfig["theme"]["bg_one"];
    bodyEl.style.color = interfaceConfig["theme"]["color_one"];

    const subDivs = document.getElementsByClassName("bg2");
    for (let i = 0; i < subDivs.length; ++i) {
        const element = subDivs[i] as HTMLDivElement;
        element.style.backgroundColor = interfaceConfig["theme"]["bg_two"];
        element.style.color = interfaceConfig["theme"]["color_two"];
    }
}